import { createContext } from 'react'

type SaveIndicatorState = {
  isDirty: boolean
  isError: boolean
  isSaving: boolean
  reset: () => void
  setIsDirty: (isDirty: boolean) => void
  setIsError: (error: boolean) => void
  setIsSaving: (isSaving: boolean) => void
}

const DEFAULT_VALUES = {
  isDirty: false,
  isError: false,
  isSaving: false,
  reset: () => {},
  setIsDirty: () => {},
  setIsError: () => {},
  setIsSaving: () => {},
} as SaveIndicatorState

export const SaveIndicatorContext = createContext<SaveIndicatorState>(DEFAULT_VALUES)
SaveIndicatorContext.displayName = 'SaveIndicatorContext'
